export enum CalendarView {
  Month = 'month',
  Week = 'week',
  Day = 'day'
}

export enum CustomCalendarView {
  Timeline = 'Timeline'
}
